import { backoffice } from "../../../utils/axios/backoffice";

export async function getAllEmployees() {
  try {
    const { data } = await backoffice.get("/employees-list");

    if (data.ok) {
      return data.data;
    } else {
      console.log(data.error);
      return {};
    }
  } catch (error) {
    console.log(error.message);
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/views/NaduChat/utils/getAllEmployees.js